import poweredBySellarImg from "../../../../images/powered-by-sellar.svg";

export const PoweredBySellar = () => {
  return (
    <a
      href={"https://sellar.io"}
      className={"m-auto"}
      target="_blank"
      rel="noreferrer"
    >
      <img
        className={"w-[140px]"}
        src={poweredBySellarImg}
        alt={"Powered by Sellar"}
      />
    </a>
  );
};
